import { send } from 'server';

export * from 'js/components/main/Jumio/server';

export const verifyNow = ({ successUrl, errorUrl, documentType }) => send({
    ID: 35688,
    description: 'Initiate document upload request',
    responses: [35689, 35690],
    service: 'netverify',
    successUrl,
    errorUrl,
    documentType
}, true);
